// extracted by mini-css-extract-plugin
export default {"searchBox":"SearchInput_searchBox__jS6qp","input":"SearchInput_input__pvo3q","iconBox":"SearchInput_iconBox__gba5J"};